import api from './api';

export interface ManejadorAutorizacao {
  nome: string;
  cpf: string;
  cr: string;
  socio_id?: number | null;
}

export interface AutorizacaoPreenchimento {
  fazenda_id: number;
  nome_fazenda: string;
  endereco?: string;
  cidade?: string;
  estado?: string;
  latitude?: string;
  longitude?: string;
  car?: string;
  telefone_proprietario?: string;
  proprietario_nome?: string;
  proprietario_rg?: string;
  proprietario_cpf?: string;
  cidade_emissao?: string;
  manejadores_sugeridos: ManejadorAutorizacao[];
  socios_para_manejador: { id: number; nome_completo: string; cpf: string; cr?: string }[];
}

export interface AutorizacaoFazenda {
  id: number;
  fazenda_id: number;
  pdf_url?: string;
  data_emissao: string;
}

export const autorizacaoFazendaService = {
  async preenchimento(fazendaId: number): Promise<AutorizacaoPreenchimento> {
    const res = await api.get<AutorizacaoPreenchimento>(
      `/api/fazendas/${fazendaId}/autorizacao/preenchimento`,
    );
    return res.data;
  },

  async gerar(
    fazendaId: number,
    payload: {
      proprietario_nome: string;
      proprietario_rg?: string;
      proprietario_cpf?: string;
      manejadores: ManejadorAutorizacao[];
      cidade_emissao?: string;
    },
  ): Promise<AutorizacaoFazenda> {
    const res = await api.post<AutorizacaoFazenda>(`/api/fazendas/${fazendaId}/autorizacao`, {
      ...payload,
      atualizar_fazenda: true,
    });
    return res.data;
  },

  async baixarPdf(autorizacaoId: number): Promise<Blob> {
    const res = await api.get(`/api/fazendas/autorizacao/${autorizacaoId}/pdf`, {
      responseType: 'blob',
    });
    return res.data;
  },
};
